class ModularCode {
  constructor() {
    this.N = 26 * 10 * 26 * 10 * 26;


    this.A = 10007;     
    this.B = 12345;     

    this.letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

    if (this.gcd(this.A, this.N) !== 1) {
      throw new Error(`A (${this.A}) não é coprimo de N (${this.N}).`);
    }

    this.A_inv = this.modInverse(this.A, this.N);
  }


  gcd(a, b) { while (b !== 0) [a, b] = [b, a % b]; return Math.abs(a); }

  modInverse(a, m) {
    let m0 = m, x0 = 0, x1 = 1;
    a = ((a % m) + m) % m;
    if (m === 1) return 0;
    while (a > 1) {
      const q = Math.floor(a / m);
      [a, m] = [m, a % m];
      [x0, x1] = [x1 - q * x0, x0];
      if (m === 0 && a !== 1) throw new Error("Inverso modular não existe.");
    }
    return (x1 + m0) % m0;
  }

  _unpack(codeNum) {
    const L1 = Math.floor(codeNum / (26*10*26*10)) % 26; 
    const N1 = Math.floor(codeNum / (26*10*26)) % 10;    
    const L2 = Math.floor(codeNum / (10*26)) % 26;       
    const N2 = Math.floor(codeNum / 26) % 10;            
    const L3 = codeNum % 26;
    return { L1, N1, L2, N2, L3 };
  }

  _pack({ L1, N1, L2, N2, L3 }) {
    return (
      L1 * 26*10*26*10 +
      N1 * 26*10*26 +
      L2 * 10*26 +
      N2 * 26 +
      L3
    );
  }

  encodeID(id) {
    id = Number(id);
    if (!Number.isInteger(id) || id < 0) throw new Error("ID inválido");

    const idMod = id % this.N;

    const codeNum = (idMod * this.A + this.B) % this.N;
    const { L1, N1, L2, N2, L3 } = this._unpack(codeNum);

    return (
      this.letters[L1] +
      String(N1) +
      this.letters[L2] +
      String(N2) +
      this.letters[L3]
    );
  }

  encodeShopifyId(rawId) {
    return this.encodeID(Number(rawId));
  }

  decodeCode(code) {
    if (!code) return null;
    code = code.replace(/^#/, '').toUpperCase();
    if (code.length !== 5) return null;

    const L1 = this.letters.indexOf(code[0]);
    const N1 = parseInt(code[1], 10);
    const L2 = this.letters.indexOf(code[2]);
    const N2 = parseInt(code[3], 10);
    const L3 = this.letters.indexOf(code[4]);

    if ([L1, L2, L3].some(x => x < 0) || [N1, N2].some(n => Number.isNaN(n))) {
      return null;
    }

    const codeNum = this._pack({ L1, N1, L2, N2, L3 });

    let idMod = ((codeNum - this.B) * this.A_inv) % this.N;
    if (idMod < 0) idMod += this.N;
    return idMod; 
  }
}

window.ModularCode = ModularCode;
